<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible="visible"
      :title="$l('dialog_title_order_file_info') || '订单附件'"
      direction="rtl"
      :size="900"
      @close="close"
    >
      <div class="drawer-wapper-info">
        <FileTable ref="main" :orderCode="orderCode" />
      </div>
    </el-drawer>
  </div>
</template>
<script>
import FileTable from './file-table.vue'
export default {
  components: { FileTable },
  props: {
    visible: { type: Boolean, default: false },

    orderCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-wapper-info {
  padding: 0 30px;
}
</style>
